import { RouterService } from '../../router-service';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ServiceFactory, IServiceFactory } from '../../service-factory';

@Injectable({
    providedIn: 'root'
  })

  export class LoggedInGuard implements CanActivate {

    routerService: RouterService;
    constructor(
        private serviceFactory: IServiceFactory, 
        private router: Router
        ) {
        this.routerService = this.serviceFactory.getRouterService();
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    {
        return this.routerService.IsLoggedIn().pipe(
            map( isLoggedIn => {
                if(isLoggedIn.LoggedIn){
                   return this.router.parseUrl('/ELearning/Course');
                }
                else{
                    return true;
                }
            }),
            catchError((err) => {
                //this.router.parseUrl('/ELearning/Course');
                return of(false);
            })
    
        );
    }
  }

  